module.exports = __webpack_public_path__ + "img/logo-satab-responsive.3b30a41f.png";